import {isDefined, isNumeric, isTrue as isTrueUtil} from "../../libs/utils/epic.utils";
import {SettingKey} from "../../base/setting-key.enum";

export class SettingDto {

  public key!: SettingKey;
  public value: string | undefined;

  constructor(init?: Partial<SettingDto>) {
    Object.assign(this, init);
  }

  public static of(key: SettingKey, value: string): SettingDto {
    return new SettingDto({key, value});
  }

  public isTrue(): boolean {
    return isTrueUtil(this.value);
  }

  public isFalse(): boolean {
    return !this.isTrue();
  }

  public hasValue(): boolean {
    return isDefined(this.value);
  }

  public asNumber(): number | undefined {
    return isNumeric(this.value) ? Number(this.value) : undefined;
  }

  public asBoolean(): boolean {
    if (this.isTrue()) {
      return true;
    } else if (this.isFalse()) {
      return false;
    }
    throw new Error('Value is neither true nor false');
  }
}
